export const videoEditingFaqs = [
  {
    question: "What kind of video editing services do you offer?",
    answer:
      "We provide: Wedding highlight films, Full-length documentary edits, Instagram Reels & Shorts, Corporate and promotional videos, Cinematic trailers and teaser edits, Music sync and storytelling edits.",
  },
  {
    question: "What formats do you accept for raw footage?",
    answer:
      "We accept most common video formats, including MP4, MOV, AVI, MXF, and footage from DSLRs, drones, GoPros, and mobile phones. You can send files via cloud storage (Google Drive, Dropbox, WeTransfer, etc.).",
  },
  {
    question: "What’s your turnaround time?",
    answer:
      "Typical delivery: Short-form videos (reels, trailers): 2–4 days, Wedding highlight: 5–7 days, Full wedding film or long-form content: 7–14 days.",
  },
  {
    question: "Can I request revisions?",
    answer:
      "Yes, we offer up to 3 free rounds of revisions to make sure you're 100% satisfied with the final video.",
  },
  {
    question: "Do you add color grading and transitions?",
    answer:
      "Definitely. We include: Color correction & cinematic grading, Smooth transitions, Stylized titles/lower-thirds, Motion effects or stabilization (if needed).",
  },
];
